var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6c6 0 10 6 10 6s-4 6-10 6-10-6-10-6 4-6 10-6zm-8.5 6.3c.5.7 1.2 1.3 1.9 1.9C7.4 16 9.6 17 12 17c2.4 0 4.6-1 6.6-2.8.7-.6 1.4-1.3 1.9-1.9.1-.1.2-.2.2-.3-.1-.1-.2-.2-.2-.3-.6-.7-1.2-1.3-1.9-1.9C16.6 8 14.4 7 12 7 9.6 7 7.4 8 5.4 9.8c-.7.6-1.4 1.2-1.9 1.9-.1.1-.2.2-.2.3 0 .1.1.2.2.3zM12 14a2 2 0 10.001-3.999A2 2 0 0012 14z",
    fill: "#1998D5"
  })));
}
export default SvgView;